var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.521 13.459a2.76 2.76 0 0 0-1.996.853l-6.407-3.605a2.764 2.764 0 0 0 0-1.423l6.407-3.605a2.762 2.762 0 1 0-.681-1.206L6.437 8.078a2.77 2.77 0 1 0 0 3.835l6.407 3.605a2.77 2.77 0 1 0 2.678-2.06Z",
    fill: "currentColor"
  })));
};
export default SvgShare;